Revolution.Module.extend({
    NAME: "mde.results", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/results.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        // console.log("module " + this.NAME);

        //_.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        if ($('.js-results-map').length) {
            $.getJSON( "assets/json/markers.json", _.bind(function(data) {
                this.refreshMarkers(data);
                this.centerMap();

                var imgs = $('.js-list-results').find('.lazy:not(b-loaded)');
                window.bLazy.load(imgs);

                $.fn.matchHeight._apply($('[data-mh="mh-infos-content"]'));
            }, this));
        }


        $('.placecomplete').placecomplete({
            placeServiceResult:function(data,status){
                $('input.js-selected_address').val(data.adr_address);
            },
            placeholderText: "Rechercher...",
            language:'fr'
        });

    },

    onWindowLoad: function (e) {},
    onWindowScroll: function (e) {},
    onWindowResize: function (e) {
        $.fn.matchHeight._apply($('[data-mh="mh-infos-content"]'))
    },

    iconMap: function() {
        return {
            path: "M23.5,0C11.3,0,0.2,9.9,0.2,22.2C0.2,34.4,10.3,49,23.5,70c13.2-21,23.3-35.6,23.3-47.8C46.8,9.9,35.7,0,23.5,0z M23.5,32.1c-4.8,0-8.7-3.9-8.7-8.8c0-4.8,3.9-8.8,8.7-8.8c4.8,0,8.7,3.9,8.7,8.8C32.2,28.2,28.3,32.1,23.5,32.1z",
            fillColor: '#f8ac00',
            fillOpacity: 1,
            size: new google.maps.Size(47, 70),
            anchor: new google.maps.Point(20, 70),
            strokeWeight: 0,
            scale: 1
        }
    },

    htmlItemList: function(item, point) {
        var $html = $($('#template-results-list').html());
        $html.find('.img-wrapper img').attr('data-src', point.img);
        $html.find('.img-wrapper img').attr('alt', point.title);
        $html.find('.tag-stick').html(point.type);
        $html.find('.tag-right').append(' '+point.type_offer);
        $html.find('.infos-link').attr('href', '#');
        $html.find('.top-text').html(point.title+' - '+point.surface+' m2');
        $html.find('.address-text').html(item.address);
        $html.find('.address-city').html(item.city+' ('+item.zipcode+')');
        $html.find('.bottom-text').prepend(point.price+' ');
        $html.find('.tag:not(.only-large)').prepend('Divisible');
        $html.find('.tag.only-large').prepend('Offre divisible à partir de '+point.surface+' m2');

        return $html;
    },

    htmlPopup: function(item) {
        var $htmlPopup = $($('#template-popup-marker').html());
        var $swiperWrapper = $htmlPopup.find('.swiper-wrapper');

        for (var index = 0; index < item.points.length; index++) {
            var elmt = item.points[index];

            var $htmlSlide = $($('#template-popup-slide').html());
            $htmlSlide.find('.img-wrapper img').attr('data-src', elmt.img);
            $htmlSlide.find('.img-wrapper img').attr('alt', elmt.title);
            $htmlSlide.find('.img-link').attr('href', '#');
            $htmlSlide.find('.marker-title-link').attr('href', '#');
            $htmlSlide.find('.marker-title').prepend(elmt.title+' - '+elmt.surface+' ');
            $htmlSlide.find('.marker-address').html(item.city+' ('+item.zipcode+')');
            $htmlSlide.find('.marker-price').prepend(elmt.price+' ');

            $swiperWrapper.append($htmlSlide);
        }

        // if (item.points.length == 1) {
        //     $htmlPopup.find('.swiper-button-next').remove();
        //     $htmlPopup.find('.swiper-button-prev').remove();
        // }
        return $htmlPopup;
    },

    centerMap: function() {
        window.map.panToBounds(window.bounds);
        window.map.fitBounds(window.bounds);
    },

    resetMarkers: function() {
        // Loop through markers and set map to null for each
        for (var i=0; i<window.markers.length; i++) {
            window.markers[i].setMap(null);
        }

        // Reset the markers array
        window.markers = [];
    },

    refreshMarkers: function (listMarkers) {
        this.resetMarkers();
        // var enabledMarker = null;

        $.each(listMarkers, _.bind(function(i, item) {
            var location = new google.maps.LatLng(item.lat, item.lng);

            var numberOnPin = item.status !== "precise" ? item.points.length : '';
            var customMarker = new window.TextMarker(location, numberOnPin, item.status);

            customMarker.addContent(this.htmlPopup(item));

            $.each(item.points, _.bind(function(i, point) {
                var $card = $(this.htmlItemList(item, point));
                $(".js-list-results").append($card);

                $card.find('.card-sm').on('mouseover', function() {
                    customMarker.deactivate();
                    customMarker.hover();
                })
                $card.find('.card-sm').on('mouseout', function() {
                    customMarker.out();
                })
            }, this));

            window.bounds.extend(location);

            window.map.addListener('click', function(e) {
                customMarker.deactivate();
			});

            window.markers.push(customMarker);
        }, this));

        window.markerclusterer.addMarkers(window.markers, true);
    }
});
